// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UC9WE","left":"styles_left__3j8hb","desktopActions":"styles_desktopActions__UKvvT","title":"styles_title__2WW70"};